import * as React from 'react';
import {CircularProgress, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useDarkMode} from '../../darkMode/hook/useDarkMode';
import {useUserInfo} from '../../userInfo/hooks/useUserInfo';

export default function ProfileButton({text, icon, link, onClick, loading}) {
  const navigate = useNavigate();
  const {mode} = useDarkMode();
  const {profil} = useUserInfo();
  const [disabled, setDisabled] = React.useState(true);

  React.useEffect(() => {
    if (profil && profil.subscriptionStatus !== 'active') {
      console.log('atoooo');
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [profil]);

  return (
    <button
      className={'profileButton'}
      disabled={loading || disabled}
      onClick={() => {
        if (onClick) {
          onClick();
          return;
        }

        if (!disabled) {
          window.location.replace(link);
        }
      }}
      style={{backgroundColor: mode.settings.inputBackgroundColor}}>
      {!loading && <img src={icon} alt={text} />}
      {loading && <CircularProgress size={20} color={'inherit'} />}
      &nbsp;
      <Typography
        variant={'subtitle5'}
        sx={{marginLeft: '4px'}}
        color={mode.settings.textColor3}>
        {text}
      </Typography>
    </button>
  );
}
